import React, { Fragment, Component } from "react"
import { Helmet } from "react-helmet"
import PropTypes from "prop-types"
import { ThemeProvider } from "styled-components"
import { translate } from "react-i18next"
import { connect } from "react-redux"
import { compose } from "redux"
import { ReportGeneration, ReportRequests } from "../../components/custom-report"
import Tabs from "../../components/layout/navigation/Tabs"
import DashboardLoadingSpinner from "../../components/DashboardLoadingSpinner"

class CustomReport extends Component {
  static propTypes = {
    theme: PropTypes.shape({
      primaryColor: PropTypes.string.isRequired,
      primaryColorHover: PropTypes.string.isRequired,
      navBackgroundColor: PropTypes.string.isRequired,
    }).isRequired,
    t: PropTypes.func.isRequired,
    dashboard: PropTypes.shape({
      isLoading: PropTypes.bool,
    }).isRequired,
  }

  state = {
    activeTab: 1,
  }

  render() {
    const { t, dashboard, theme } = this.props
    const title = t("Dashboards.Names.CustomReport")
    const tabNames = [
      { id: 1, name: "CustomReport.MainTabs.CreateReport" },
      { id: 2, name: "CustomReport.MainTabs.PreviousReport" },
    ]
    // let activeTab = 1
    const tabClicked = (tab) => {
      this.setState({ activeTab: tab.id })
    }
    // If on tablet or mobile need to ensure that the container is 
    // brought down underneath the heading.
    let containerStyle = {};
    if (window.innerWidth < 1200) {
      containerStyle = {
        marginTop: '50px'
      };
    }
    return (
      <ThemeProvider theme={theme}>
        <Fragment>
          <Helmet>
            <title>{title}</title>
          </Helmet>
          {dashboard.isLoading ? (
            <DashboardLoadingSpinner />
          ) : (
            <div style={containerStyle} className="container">
              <Tabs
                tabDetails={tabNames}
                onTabChange={tabClicked}
                activeTab={this.state.activeTab}
              />
              {this.state.activeTab === 1 ? (
                <ReportGeneration switchTabs={() => tabClicked(tabNames[1])} />
              ) : (
                <ReportRequests />
              )}
            </div>
          )}
        </Fragment>
      </ThemeProvider>
    )
  }
}

function mapStateToProps(state) {
  return {
    dashboard: state.customReport,
    theme: state.userDetail.theme,
  }
}

export default compose(translate(), connect(mapStateToProps))(CustomReport)



// WEBPACK FOOTER //
// ./src/routes/dashboards/CustomReport.jsx